// ---------------------------------------------------------------
// EnquiryOps single point of configuration for external links.
// Swap these placeholders with real URLs when ready — nothing else
// in the codebase needs to change.
// ---------------------------------------------------------------

// Stripe Payment Link for the $199 refundable founding deposit.
export const STRIPE_PAYMENT_LINK =
  process.env.REACT_APP_STRIPE_PAYMENT_LINK ||
  "https://buy.stripe.com/8x2eVdeF21LHc9G7l37Vm00";

// Booking link for the post-deposit fit call.
export const FIT_CALL_BOOKING_LINK =
  process.env.REACT_APP_FIT_CALL_LINK ||
  "https://calendar.app.google/hUyyim4A33xUCbTt8";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const BRAND = {
  name: "EnquiryOps",
  tagline: "The Enquiry-to-Revenue OS",
  supportEmail: "paul@getenquiryops.com",
};
